import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFi = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 17 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_9162_14647",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 17,
		height: 17,
		children: /* @__PURE__ */ _jsx("circle", {
			cx: 8.5,
			cy: 8.5,
			r: 8.5,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsxs("g", {
		mask: "url(#mask0_9162_14647)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M-1 0H24V17H-1V0Z",
			fill: "white"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M24 6.44037V10.5596H8.94629V17H4.9082V10.5596H-1V6.44037H4.9082V0H8.94629V6.44037H24Z",
			fill: "#2E52B2"
		})]
	})]
});
export default SvgFi;
